<div class="checkout-payment" *ngIf="activeOrder">
    <div class="space-y-8">
        <div class="checkout-payment__cancel-section">
            <button (click)="cancelPayment()" class="checkout-payment__cancel-button" aria-label="Cancel payment process">
                <img src="assets/icons/close-icon.svg" class="w-3 h-3 text-red-500" alt="Cancel">
                Cancel Payment Process
            </button>
        </div>

        <vsf-checkout-addresses
            class="block"
            [signedIn]="signedIn$ | async"
            [activeOrder]="activeOrder"
            [customerAddresses]="customerAddresses$ | async"
            [availableCountries]="availableCountries$ | async"
            [shippingAddressMissingPhone]="shippingAddressMissingPhone"
            (selectShippingAddress)="onSelectSavedShippingAddress($event.id, $event.addresses)"
            (addShippingAddress)="openAddShippingAddress()"
            (saveGuestAddress)="saveGuestShippingAddress($event)"
            (selectBillingAddress)="onSelectSavedBillingAddress($event.id, $event.addresses)"
            (addBillingAddress)="openAddBillingAddress()"
            (useShippingAsBilling)="onUseShippingAsBilling()"
            (saveGuestBillingAddress)="saveGuestBillingAddress($event)"
        ></vsf-checkout-addresses>

        <vsf-checkout-payment-options
            class="block"
            [paymentMethods]="paymentMethods$ | async"
            [selectedPaymentMethod]="selectedPaymentMethod"
            [stripeSurchargePercent]="stripeSurchargePercent"
            [activeOrder]="activeOrder"
            (selectPaymentMethod)="selectPaymentMethod($event)"
        ></vsf-checkout-payment-options>

        <vsf-checkout-order-summary
            class="block"
            [supplierGroups]="supplierGroups"
            [activeOrderLineCount]="activeOrder.lines.length"
        ></vsf-checkout-order-summary>
    </div>
</div>
